import React, { useEffect, useState } from "react";
import VideoEmbed from "../../../../components/VideoEmbed";
import "../../../../styles/styles.css";

const PageSingleVideo = () => {
  const [finalUrl, setFinalUrl] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const videoUrl = params.get("videoUrl");
    if (videoUrl) setFinalUrl(videoUrl);
  }, []);

  if (!finalUrl) return null;

  return (
   <div
      style={{
        width: "100%",
        minHeight: "calc(100vh - 90px)",
        backgroundColor: "black",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
        margin: 0,
      }}
    >
      <VideoEmbed url={finalUrl} />
    </div>
  );
};

export default PageSingleVideo;
